import Business from "pages/business-management/business/Business";
import BusinessExtension from "pages/business-management/business-extension/BusinessExtension";
import BusinessPhoneNumber from "pages/business-management/business-phone-number/BusinessPhoneNumber";
import BusinessReports from "pages/business-management/business-reports/BusinessReports";
import BusinessUser from "pages/business-management/business-user/BusinessUser";
import EditExtension from "pages/cloudPbx/extension/EditExtension";
import InboundCall from "pages/cloudPbx/inbound-call/InboundCall";
import InboundCallV2 from "pages/cloudPbx/inbound-call-v2/InboundCall";
import OutBoundCallV2 from "pages/cloudPbx/outbound-call/OutboundCall";
import OutBoundCall from "pages/cloudPbx/OutBoundCall";
import ReportCallMeDingdong from "pages/cloudPbx/report-call-me-dingdong/ReportCallMeDingdong";
import Login from "pages/login/Login";
import ReportBusiness from "pages/reports/report-business/ReportBusiness";
import ReportChat from "pages/reports/report-chat/ReportChat";
import ReportDetailFailedInboundCall from "pages/reports/report-detail-failed-inbound-call/ReportDetailFailedInboundCall";
import ReportDetailFailedOutboundCall from "pages/reports/report-detail-failed-outbound-call/ReportDetailFailedOutboundCall";
import ReportDetailInboundCall from "pages/reports/report-detail-inbound-call/ReportDetailInboundCall";
import ReportDetailOutboundCall from "pages/reports/report-detail-outbound-call/ReportDetailOutboundCall";
import ReportExtNotCall from "pages/reports/report-ext-not-call/ReportExtNotCall";
import ReportInboundCallByExt from "pages/reports/report-inbound-call-by-ext/ReportInboundCallByExt";
import ReportLicenseBCP from "pages/reports/report-license-BCP/ReportLicenseBCP";
import ReportLicenseCSKH from "pages/reports/report-license-CSKH/ReportLicenseCSKH";
import ReportOutboundCallByExt from "pages/reports/report-outbound-call-by-ext/ReportOutboundCallByExt";
import ReportOutboundCallByUnit from "pages/reports/report-outbound-call-by-unit/ReportOutboundCallByUnit";
import ReportSynthesisFailedCall from "pages/reports/report-synthesis-failed-call/ReportSynthesisFailedCall";
import EditUser from "pages/user/EditUser";
import User from "pages/user/User";

import Admin from "./container/Admin";
import Main from "./container/Main";
import AgentChatTicket from "./pages/agent-chat-ticket";
import AgentDashboard from "./pages/agent-dashboard/AgentDashboard";
import Agents from "./pages/agents";
import AgentStatus from "./pages/agents/AgentStatus";
import AgentWorkingOutbound from "./pages/agents/AgentWorkingOutbound";
import CreateAgent from "./pages/agents/CreateAgent";
import ApiConnectAgent from "./pages/api-connect/Agents";
import ApiConnectLogInbound from "./pages/api-connect/CallsLogInBound";
import ApiConnectLogOutbound from "./pages/api-connect/CallsLogOutBound";
import ApiConnectExtension from "./pages/api-connect/Extensions";
import ApiConnectGroup from "./pages/api-connect/Groups";
import ApiConnectIvr from "./pages/api-connect/Ivrs";
import ApiConnectPhoneNumber from "./pages/api-connect/PhoneNumber";
import Campaign from "./pages/campaigns";
import CampaignAllocation from "./pages/campaigns/CampaignAllocation";
import CampaignConfig from "./pages/campaigns/CampaignConfig";
import CampaignGroup from "./pages/campaigns/CampaignGroup";
import CampaignService from "./pages/campaigns/CampaignService";
import CallFlow from "./pages/cloudPbx/call-flow/CallFlow";
import CallflowNumber from "./pages/cloudPbx/CallflowNumber";
import CustomerCalls from "./pages/cloudPbx/CustomerCalls";
import Dialplan from "./pages/cloudPbx/Dialplan";
import Extension from "./pages/cloudPbx/extension/Extension";
import Ivr from "./pages/cloudPbx/ivr/Ivr";
import LiveChatComponent from "./pages/cloudPbx/LiveChat";
import MonitorPbx from "./pages/cloudPbx/Monitor";
import PartnerSwitchboard from "./pages/cloudPbx/PartnerSwitchboard";
import PhoneNumber from "./pages/cloudPbx/PhoneNumber";
import PostmanCalls from "./pages/cloudPbx/PostmanCalls";
import Queue from "./pages/cloudPbx/queue/Queue";
import Sound from "./pages/cloudPbx/Sound";
import SubscribeComponent from "./pages/cloudPbx/Subscribe";
import TimeRing from "./pages/cloudPbx/TimeRing";
import WorkTime from "./pages/cloudPbx/WorkTime";
import Dashboard from "./pages/dashboard/Dashboard";
import AgentGroups from "./pages/groups/AgentGroups";
import CreateGroup from "./pages/groups/CreateGroup";
import CustomerGroups from "./pages/groups/CustomerGroups";
import logs from "./pages/logs";
import Account from "./pages/miniCrm/Account";
import AgentLog from "./pages/miniCrm/AgentLog";
import AgentSession from "./pages/miniCrm/AgentSession";
import Article from "./pages/miniCrm/Article";
import Comment from "./pages/miniCrm/Comment";
import Contact from "./pages/miniCrm/Contact";
import ContactFile from "./pages/miniCrm/ContactFile";
import CreateContact from "./pages/miniCrm/CreateContact";
import KnowledgeBase from "./pages/miniCrm/KnowledgeBase";
import Stages from "./pages/miniCrm/Stages";
import Ticket from "./pages/miniCrm/ticket/Ticket";
import Topic from "./pages/miniCrm/Topic";
import VnpostPackage from "./pages/miniCrm/Vnpost";
import ContactMonitor from "./pages/monitor/Monitor";
import BigData from "./pages/profiling/BigData";
import Profiling from "./pages/profiling/Data";
import ProfilingInfo from "./pages/profiling/Info";
import AgentReport from "./pages/reports/Agent";
import AgentCallDurations from "./pages/reports/AgentCallDurations";
import AgentReportDetail from "./pages/reports/AgentReportDetail";
import AgentReportByHour from "./pages/reports/AgentReportDetailByHours";
import CallGeneratorLog from "./pages/reports/CallGeneratorLog";
import CampaignReport from "./pages/reports/CampaignReport";
import ConfigureBillingTime from "./pages/reports/ConfigureBillingTime";
import ReportInbound from "./pages/reports/InboundCallPrefomence";
import ReportOutbound from "./pages/reports/OutboundCallPrefomence";
import ReportCallChargeMonitoring from "./pages/reports/report-call-charge-monitoring";
import ReportChargeTelecom from "./pages/reports/report-charge-telecom/TelecomChargeReport";
import ReportExtension from "./pages/reports/report-extension/ReportExtension";
import ReportInboundCallByUnit from "./pages/reports/report-inbound-call-by-unit/ReportInboundCallByUnit";
import ReportInboundOutboundCalls from "./pages/reports/report-inbound-outbound-calls";
import ReportInboundPerformance from "./pages/reports/report-inbound-performance/ReportInboundPerformance";
import ReportCallOutput from "./pages/reports/ReportCallOutput";
import ReportData from "./pages/reports/ReportData";
import ReportDataByDays from "./pages/reports/ReportDataByDays";
import ReportPerformance from "./pages/reports/ReportPerformance";
import ReportQuantity from "./pages/reports/ReportQuantity";
import ReportSynthesisDaily from "./pages/reports/ReportSynthesisDaily";
import ReportTicket from "./pages/reports/ReportTicket";
import Role from "./pages/Roles";
import Gateway from "./pages/sms/Gateway";
import GatewayResponse from "./pages/sms/GatewayResponse";
import Provider from "./pages/sms/Provider";
import Route from "./pages/sms/Route";
import Sender from "./pages/sms/Sender";
import SMS from "./pages/sms/SMS";
import Status from "./pages/sms/Status";
import DataCallTeleSale from "./pages/telesale/DataCallTeleSale";
import Form from "./pages/telesale/Form";
import LogCallTelesale from "./pages/telesale/LogCallTelesale";
import Monitor from "./pages/telesale/Monitor";
import Dialpad from "./pages/web-rtc/Dialpad";

const allowEditRoute =
  process.env.NODE_ENV === "development" ||
  process.env.PUBLIC_URL === "http://web-dev.api-connect.io/vnpost" ||
  process.env.REACT_APP_PATH === "/vnpost-uat";

const routes = [
  {
    component: Main,
    routes: [
      {
        path: `${process.env.REACT_APP_PATH}/login`,
        exact: true,
        component: Login,
        name: "Đăng nhập",
      },
      {
        path: `${process.env.REACT_APP_PATH}/`,
        component: Admin,
        name: "Admin",
        routes: [
          {
            path: `${process.env.REACT_APP_PATH}/`,
            component: Dashboard,
            exact: true,
          },
          {
            path: `${process.env.REACT_APP_PATH}/id/user`,
            exact: true,
            component: User,
            name: "Danh sách tài khoản",
          },
          ...(allowEditRoute
            ? [
                {
                  path: `${process.env.REACT_APP_PATH}/id/edit-user`,
                  exact: true,
                  component: EditUser,
                  name: "Danh sách tài khoản",
                },
              ]
            : []),
          {
            path: `${process.env.REACT_APP_PATH}/id/role`,
            exact: true,
            component: Role,
            name: "Phân quyền",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/campaign`,
            exact: true,
            component: Campaign,
            name: "Chiến dịch",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/campaign-group`,
            exact: true,
            component: CampaignGroup,
            name: "Nhóm chiến dịch",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/campaign-service`,
            exact: true,
            component: CampaignService,
            name: "Dịch vụ chiến dịch",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/campaign-config/:id`,
            exact: true,
            component: CampaignConfig,
            name: "Chiến dịch",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/campaign-allocation`,
            exact: true,
            component: CampaignAllocation,
            name: "Tạo chiến dịch",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/contact`,
            exact: true,
            component: Contact,
            name: "Khách hàng",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/contact/create-contact`,
            exact: true,
            component: CreateContact,
            name: "Tạo khách hàng",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/contact/edit-contact/:id`,
            exact: true,
            component: CreateContact,
            name: "Sửa khách hàng",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent`,
            exact: true,
            component: Agents,
            name: "Nhân viên",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/account`,
            exact: true,
            component: Account,
            name: "Khách hàng",
          },
          {
            path: `${process.env.REACT_APP_PATH}/create-agent`,
            exact: true,
            component: CreateAgent,
            name: "Thêm nhân viên",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent-group`,
            exact: true,
            component: AgentGroups,
            name: "Nhóm",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/customer-group`,
            exact: true,
            component: CustomerGroups,
            name: "Nhóm",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/contact-file`,
            exact: true,
            component: ContactFile,
            name: "Nhóm",
          },
          {
            path: `${process.env.REACT_APP_PATH}/create-group`,
            exact: true,
            component: CreateGroup,
            name: "Thêm nhóm",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/interactive-log`,
            exact: true,
            component: LogCallTelesale,
            name: "Lịch sử tương tác",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/interactive-data`,
            exact: true,
            component: DataCallTeleSale,
            name: "Dữ liệu tương tác",
          },
          {
            path: `${process.env.REACT_APP_PATH}/call-center/agent-log`,
            exact: true,
            component: AgentLog,
            name: "Lịch sử làm việc điện thoại viên",
          },
          {
            path: `${process.env.REACT_APP_PATH}/call-center/agent-session`,
            exact: true,
            component: AgentSession,
            name: "Lịch sử làm việc điện thoại viên clone", // TODO
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/form`,
            exact: true,
            component: Form,
            name: "Form gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/report-call-me-dingdong`,
            exact: true,
            component: ReportCallMeDingdong,
            name: "Báo cáo Call Me Dingdong",
          },

          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/inbound-call`,
            exact: true,
            component: InboundCall,
            name: "Lịch sử gọi vào",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/inbound-call-v2`,
            exact: true,
            component: InboundCallV2,
            name: "Lịch sử gọi vào V2",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/postman-call`,
            exact: true,
            component: PostmanCalls,
            name: "Cuộc gọi bưu tá",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/customer-call`,
            exact: true,
            component: CustomerCalls,
            name: "Cuộc gọi KH đến bưu tá",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/internal-call`,
            exact: true,
            component: logs,
            name: "Lịch sử cuộc gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/outbound-call/report-campaign`,
            exact: true,
            component: CampaignReport,
            name: "Báo cáo",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent-dashboard`,
            exact: true,
            component: AgentDashboard,
            name: "Nhân viên gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent-chat-ticket`,
            exact: true,
            component: AgentChatTicket,
            name: "Chat",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/monitor`,
            exact: true,
            component: Monitor,
            name: "monitor gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/live-chat`,
            exact: true,
            component: LiveChatComponent,
            name: "Live Chat",
          },
          {
            path: `${process.env.REACT_APP_PATH}/subscribe`,
            exact: true,
            component: SubscribeComponent,
            name: "Subscribe Facebook",
          },
          {
            path: `${process.env.REACT_APP_PATH}/monitor/sumary`,
            exact: true,
            component: ContactMonitor,
            name: "monitor gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent-status`,
            exact: true,
            component: AgentStatus,
            name: "agent status",
          },
          //mini crm
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/stage`,
            exact: true,
            component: Stages,
            name: "Trạng thái làm việc",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/knowledge-base`,
            exact: true,
            component: KnowledgeBase,
            name: "Thể loại",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/article`,
            exact: true,
            component: Article,
            name: "Bài viết",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/topic`,
            exact: true,
            component: Topic,
            name: "Chủ đề",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/comment`,
            exact: true,
            component: Comment,
            name: "Bình luận",
          },
          //cloud pbx
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/extension`,
            exact: true,
            component: Extension,
            name: "máy lẻ",
          },
          ...(allowEditRoute
            ? [
                {
                  path: `${process.env.REACT_APP_PATH}/cloud-pbx/edit-extension`,
                  exact: true,
                  component: EditExtension,
                  name: "máy lẻ",
                },
              ]
            : []),
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/partner-switchboard`,
            exact: true,
            component: PartnerSwitchboard,
            name: "Tổng đài đối tác",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/number`,
            exact: true,
            component: PhoneNumber,
            name: "Đầu số",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/outbound-call`,
            exact: true,
            component: OutBoundCall,
            name: "Lịch sử gọi ra",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/outbound-call-v2`,
            exact: true,
            component: OutBoundCallV2,
            name: "Lịch sử gọi ra V2",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/queue`,
            exact: true,
            component: Queue,
            name: "Queue",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/dial-plan`,
            exact: true,
            component: Dialplan,
            name: "Dialplan",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/ivr`,
            exact: true,
            component: Ivr,
            name: "Ivr",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/sound`,
            exact: true,
            component: Sound,
            name: "Sound",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/monitor`,
            exact: true,
            component: MonitorPbx,
            name: "Giám sát hệ thống",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/config`,
            exact: true,
            component: TimeRing,
            name: "Config thời gian chờ điện thoại viên",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/report/extension`,
            exact: true,
            component: ReportExtension,
            name: "Báo cáo máy lẻ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/inboud-call-performance`,
            exact: true,
            component: ReportInbound,
            name: "Báo cáo gọi vào",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/report-care-output`,
            exact: true,
            component: ReportCallOutput,
            name: "Báo cáo sản lượng phục vụ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report/report-business`,
            exact: true,
            component: ReportBusiness,
            name: "Báo cáo kinh doanh",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report/report-license-BCP`,
            exact: true,
            component: ReportLicenseBCP,
            name: "Báo cáo license BCP",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report/report-license-CSKH`,
            exact: true,
            component: ReportLicenseCSKH,
            name: "Báo cáo license CSKH",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report/report-synthesis-daily`,
            exact: true,
            component: ReportSynthesisDaily,
            name: "Báo cáo tổng hợp hàng ngày",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/outbound-call-performance`,
            exact: true,
            component: ReportOutbound,
            name: "Báo cáo gọi ra",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/detail-failed-outbound-call`,
            exact: true,
            component: ReportDetailFailedOutboundCall,
            name: "Báo cáo chi tiết cuộc gọi ra lỗi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/detail-failed-inbound-call`,
            exact: true,
            component: ReportDetailFailedInboundCall,
            name: "Báo cáo chi tiết cuộc gọi vào lỗi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/synthesis-failed-call`,
            exact: true,
            component: ReportSynthesisFailedCall,
            name: "Báo cáo tổng hợp cuộc gọi lỗi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/detail-inbound-call`,
            exact: true,
            component: ReportDetailInboundCall,
            name: "Báo cáo chi tiết cuộc gọi vào",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/detail-outbound-call`,
            exact: true,
            component: ReportDetailOutboundCall,
            name: "Báo cáo chi tiết cuộc gọi ra",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/synthesis-outbound-call-by-ext`,
            exact: true,
            component: ReportOutboundCallByExt,
            name: "Báo cáo cuộc gọi ra theo máy lẻ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/report-ext-not-call`,
            exact: true,
            component: ReportExtNotCall,
            name: "Báo cáo chi tiết máy lẻ không phát sinh cuộc gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/synthesis-outbound-call-by-unit`,
            exact: true,
            component: ReportOutboundCallByUnit,
            name: "Báo cáo cuộc gọi ra theo đơn vị",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/synthesis-inbound-call-by-ext`,
            exact: true,
            component: ReportInboundCallByExt,
            name: "Báo cáo cuộc gọi vào theo máy lẻ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/synthesis-inbound-call-by-unit`,
            exact: true,
            component: ReportInboundCallByUnit,
            name: "Báo cáo cuộc gọi vào theo đơn vị",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report-chat`,
            exact: true,
            component: ReportChat,
            name: "Báo cáo lưu lượng cuộc chat",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/report/agent-report-outbound`,
            exact: true,
            component: AgentReport,
            name: "Báo cáo điện thoại viên",
          },

          {
            path: `${process.env.REACT_APP_PATH}/outbound-call/report-agent-call-duration`,
            exact: true,
            component: AgentCallDurations,
            name: "AgentCallDurations",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/report/agent-detail/:id`,
            exact: true,
            component: AgentReportDetail,
            name: "agent detail",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/report/agent-report-by-hour`,
            exact: true,
            component: AgentReportByHour,
            name: "agent detail",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/ticket`,
            exact: true,
            component: Ticket,
            name: "Ticket",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/report-ticket`,
            exact: true,
            component: ReportTicket,
            name: "Report Ticket",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/quantity-report`,
            exact: true,
            component: ReportQuantity,
            name: "Report Quantity",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/configure-billing-time`,
            exact: true,
            component: ConfigureBillingTime,
            name: "Configure Billing Time",
          },
          //sms
          {
            path: `${process.env.REACT_APP_PATH}/messaging/gateway`,
            exact: true,
            component: Gateway,
            name: "gateway",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/gateway-response`,
            exact: true,
            component: GatewayResponse,
            name: "gateway-response",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/provider`,
            exact: true,
            component: Provider,
            name: "provider",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/`,
            exact: true,
            component: ReportOutbound,
            name: "Báo cáo gọi ra",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/route`,
            exact: true,
            component: Route,
            name: "route",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/sender`,
            exact: true,
            component: Sender,
            name: "sender",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/sms`,
            exact: true,
            component: SMS,
            name: "sms",
          },
          {
            path: `${process.env.REACT_APP_PATH}/messaging/status`,
            exact: true,
            component: Status,
            name: "status",
          },
          //profiling
          {
            path: `${process.env.REACT_APP_PATH}/profiling/msisdn-profile`,
            exact: true,
            component: Profiling,
            name: "Profiling",
          },
          {
            path: `${process.env.REACT_APP_PATH}/profiling/info`,
            exact: true,
            component: ProfilingInfo,
            name: "Profiling info",
          },
          {
            path: `${process.env.REACT_APP_PATH}/profiling/big-data`,
            exact: true,
            component: BigData,
            name: "BigData",
          },
          ///api connect
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/phonenumbers`,
            exact: true,
            component: ApiConnectPhoneNumber,
            name: "Api connect phone number",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/ivrs`,
            exact: true,
            component: ApiConnectIvr,
            name: "Api connect Ivr",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/groups`,
            exact: true,
            component: ApiConnectGroup,
            name: "Api connect group",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/agents`,
            exact: true,
            component: ApiConnectAgent,
            name: "Api connect agent",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/extensions`,
            exact: true,
            component: ApiConnectExtension,
            name: "Api connect extension",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/call-logs/inbound`,
            exact: true,
            component: ApiConnectLogInbound,
            name: "Api connect log inbound",
          },
          {
            path: `${process.env.REACT_APP_PATH}/api-connect/call-logs/outbound`,
            exact: true,
            component: ApiConnectLogOutbound,
            name: "Api connect log outbound",
          },
          // {
          //     path: `${process.env.REACT_APP_PATH}/api-connect/domains`,
          //     exact: true,
          //     component: ApiConnectPhoneNumber,
          //     name: 'Api connect phone number'
          // },
          //sipjs
          {
            path: `${process.env.REACT_APP_PATH}/web-rtc`,
            exact: true,
            component: Dialpad,
            name: "web rtc",
          },

          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/inbound-call/report-agent-peformance`,
            exact: true,
            component: ReportInboundPerformance,
            name: "Báo cáo năng suất gọi vào",
          },
          //report new
          // {
          //     path: `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance-days`,
          //     exact: true,
          //     component: ReportPerformenceByDate,
          //     name: 'Báo cáo năng suất theo khoảng ngày'
          // },
          // {
          //     path: `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance-per-day`,
          //     exact: true,
          //     component: ReportAgentPerformencePerDay,
          //     name: 'Báo cáo năng suất theo khoảng ngày'
          // },
          // {
          //     path: `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance-group`,
          //     exact: true,
          //     component: ReportPerformanceByGroup,
          //     name: 'Báo cáo năng suất theo nhóm'
          // },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/data-report`,
            exact: true,
            component: ReportData,
            name: "Báo cáo dữ liệu",
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/data-report-by-days`,
            exact: true,
            component: ReportDataByDays,
            name: "Báo cáo dữ liệu",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report-call-charge-monitoring`,
            exact: true,
            component: ReportCallChargeMonitoring,
            name: "Báo cáo giám sát cước cuộc gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report-charge-telecom`, // TODO chưa sử dụng trang này
            exact: true,
            component: ReportChargeTelecom,
            name: "Báo cáo đối soát cước viễn thông",
          },
          {
            path: `${process.env.REACT_APP_PATH}/report-inbound-outbound-calls`,
            exact: true,
            component: ReportInboundOutboundCalls,
            name: "Quản lý cuộc gọi vào và cuộc gọi ra",
          },
          // {
          //     path: `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance-by-agent`,
          //     exact: true,
          //     component: AgentPerformence,
          //     name: 'Báo cáo năng xuất điện thoại viên'
          // },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance`,
            exact: true,
            component: ReportPerformance,
            name: "Báo cáo năng suất", // TODO tên thực tế: Báo cáo năng suất gọi ra
          },
          {
            path: `${process.env.REACT_APP_PATH}/mini-crm/call-generator-log`,
            exact: true,
            component: CallGeneratorLog,
            name: "Báo cáo cuộc gọi tự động",
          },
          {
            path: `${process.env.REACT_APP_PATH}/contact-center/agent-call-out`,
            exact: true,
            component: AgentWorkingOutbound,
            name: "agent-call-out",
          },
          {
            path: `${process.env.REACT_APP_PATH}/vn-post/package`,
            exact: true,
            component: VnpostPackage,
            name: "Quản lý bưu cục",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/call-flow`,
            exact: true,
            component: CallFlow,
            name: "Thiết lập luồng cuộc gọi",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/work-time`,
            exact: true,
            component: WorkTime,
            name: "Work Time",
          },
          {
            path: `${process.env.REACT_APP_PATH}/cloud-pbx/callflow-number`,
            exact: true,
            component: CallflowNumber,
            name: "Call flow Number",
          },
          {
            path: `${process.env.REACT_APP_PATH}/business-management/business`,
            exact: true,
            component: Business,
            name: "Quản lý nghiệp vụ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/business-management/business-phone-number`,
            exact: true,
            component: BusinessPhoneNumber,
            name: "Quản lý đầu số nghiệp vụ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/business-management/user`,
            exact: true,
            component: BusinessUser,
            name: "Quản lý người dùng nghiệp vụ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/business-management/extension`,
            exact: true,
            component: BusinessExtension,
            name: "Quản lý máy lẻ nghiệp vụ",
          },
          {
            path: `${process.env.REACT_APP_PATH}/business-management/report`,
            exact: true,
            component: BusinessReports,
            name: "Danh sách báo cáo",
          },
        ],
      },
    ],
  },
];

export default routes;
